import * as React from "react";

function SvgClose(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg style={{ color: 'var(--brand, #365d7e)' }} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clip-path="url(#clip0_744_665)">
    <path d="M10.2129 0.638672C10.5306 0.321001 11.0437 0.321001 11.3613 0.638672C11.6791 0.95635 11.6791 1.46946 11.3613 1.78711L7.14844 6L11.3613 10.2129C11.6791 10.5306 11.6791 11.0446 11.3613 11.3623C11.2029 11.5205 10.9949 11.5996 10.7871 11.5996C10.5793 11.5996 10.3713 11.5205 10.2129 11.3623L6 7.14844L1.78711 11.3623C1.62871 11.5205 1.42066 11.5996 1.21289 11.5996C1.00517 11.5996 0.796968 11.5205 0.638672 11.3623C0.320856 11.0446 0.320856 10.5306 0.638672 10.2129L4.85156 6L0.638672 1.78711C0.320877 1.46946 0.320919 0.95635 0.638672 0.638672C0.956345 0.320992 1.46933 0.321032 1.78711 0.638672L6 4.85156L10.2129 0.638672Z" fill="currentColor" stroke="currentColor" stroke-width="0.2"/>
    </g>
    <defs>
    <clipPath id="clip0_744_665">
    <rect width="12" height="12" fill="white"/>
    </clipPath>
    </defs>
    </svg>

  );
}

export default SvgClose;
